import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import DialogShell from './DialogShell';

/** Asks for one piece of text (a reason, remarks) before an action. */
export default function TextPromptDialog({
  open,
  title,
  message,
  label = 'Reason',
  required,
  submitLabel = 'Confirm',
  submitColor,
  onClose,
  onSubmit,
}: {
  open: boolean;
  title: string;
  message?: string;
  label?: string;
  required?: boolean;
  submitLabel?: string;
  submitColor?: 'primary' | 'error' | 'warning' | 'success';
  onClose: () => void;
  onSubmit: (text: string) => Promise<void> | void;
}) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setText('');
  }, [open]);

  const submit = async () => {
    setBusy(true);
    try {
      await onSubmit(text.trim());
    } finally {
      setBusy(false);
    }
  };

  return (
    <DialogShell
      open={open}
      title={title}
      onClose={onClose}
      onSubmit={submit}
      submitLabel={submitLabel}
      submitColor={submitColor}
      busy={busy}
      disabled={required && !text.trim()}
    >
      {message && <Typography>{message}</Typography>}
      <TextField label={label} size='small' multiline minRows={2} required={required} value={text} onChange={(e) => setText(e.target.value)} autoFocus />
    </DialogShell>
  );
}
